import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../components/Sidebar";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";

export const CollegeManager = () => {
    const fileInputRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [colleges, setColleges] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(30);
  const [pagination, setPagination] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [categories, setCategories] = useState([]);
  const [courses, setCourses] = useState([]);
  const [userRole, setUserRole] = useState(localStorage.getItem("userData"));
  const navigate = useNavigate()
    const handleButtonClick = () => {
      fileInputRef.current.click(); // Opens file picker
    };
  // Fetch categories and courses
  useEffect(() => {
    fetchCategories();
    fetchCourses();
  }, []);

  const fetchCategories = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/category/all`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      const categoryOptions = response.data.data?.map(cat => ({
        value: cat._id,
        label: cat.name
      })) || [];
      setCategories([{ value: "", label: "All Categories" }, ...categoryOptions]);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-all-courses`, {
        headers: { "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`, },
      });
      const courseOptions = response.data.users?.map(course => ({
        value: course._id,
        label: course.name
      })) || [];
      setCourses([{ value: "", label: "All Courses" }, ...courseOptions]);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  // Fetch colleges from backend with pagination and filters
  const fetchColleges = async () => {
    try {
      const params = {
        search: searchQuery,
        page: currentPage,
        limit: rowsPerPage,
        fromDate: startDate,
        toDate: endDate
      };

      if (selectedCategory) {
        params.category = selectedCategory;
      }
      if (selectedCourse) {
        params.course = selectedCourse;
      }

      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/get-all-colleges`, {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      
      setColleges(response.data.users || []);
      setPagination(response.data.pagination || {});
    } catch (error) {
      console.error("Error fetching colleges:", error);
    }
  };

  useEffect(() => {
    fetchColleges();
  }, [searchQuery, currentPage, selectedCategory, selectedCourse, startDate, endDate]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      await axios.post(`${process.env.REACT_APP_BASE_URL}/bulk-upload-colleges`, formData, {
        headers: { 
          "Content-Type": "multipart/form-data",
          Authorization: `${localStorage.getItem("token")}`,
         },
      });
      fetchColleges()
    } catch (error) {
      console.error("Upload Error:", error);
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  // Handle closing the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

    // Handle confirming the deletion
    const confirmDeletion = async() => {
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/delete-college/${deleteId}`,{
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      })
      fetchColleges()
      setDeleteId("")
      closeModal();
    };

  // Handle Reset
  const handleReset = () => {
    setSearchQuery("");
    setStartDate("");
    setEndDate("");
    setSelectedCategory("");
    setSelectedCourse("");
    setCurrentPage(1);
  };

  useEffect(() => {
    if (localStorage.getItem("userData")) {
      setUserRole(JSON.parse(localStorage.getItem("userData")))
    }
  }, [])

  return (
    <div className="min-h-screen flex bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-black">College Manager</h1>
         {(userRole?.role === "admin" || userRole?.managers?.["College Manager"]?.add) && <div className="flex gap-4">
            <NavLink
              to="/add-college"
              className="bg-blue text-white px-6 py-2 rounded-md shadow-md"
            >
              + Add College
            </NavLink>
            <input 
        type="file" 
        accept=".xlsx, .csv" 
        ref={fileInputRef} 
        onChange={handleFileChange} 
        style={{ display: "none" }} 
      />
            <button
              className="bg-orange text-white px-6 py-2 rounded-md shadow-md"
              onClick={handleButtonClick}
            >
              Upload CSV
            </button>
          </div>}
        </div>

        {/* Search Filters */}
        <div className="bg-white p-4 shadow-md rounded-lg mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <input
              type="text"
              placeholder="Search by name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="border border-gray-300 rounded-md px-4 py-2"
            />
            
            <Select
              value={categories.find(cat => cat.value === selectedCategory)}
              onChange={(selected) => setSelectedCategory(selected?.value || "")}
              options={categories}
              placeholder="Select Category"
              className="w-full"
            />
            
            <Select
              value={courses.find(course => course.value === selectedCourse)}
              onChange={(selected) => setSelectedCourse(selected?.value || "")}
              options={courses}
              placeholder="Select Course"
              className="w-full"
            />
            
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="border border-gray-300 rounded-md px-4 py-2"
            />
            
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="border border-gray-300 rounded-md px-4 py-2"
            />
            
            <div className="flex gap-2">
              <button
                onClick={() => setCurrentPage(1)}
                className="bg-blue text-white px-4 py-2 rounded-md shadow-md"
              >
                Search
              </button>
              <button
                onClick={handleReset}
                className="bg-orange text-white px-4 py-2 rounded-md shadow-md"
              >
                Reset
              </button>
            </div>
          </div>
        </div>

        {/* Data Table */}
        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
          <table className="table-auto w-full">
            <thead className="bg-blue text-white">
              <tr>
                <th className="px-4 py-2">ID</th>
                <th className="px-4 py-2">Name</th>
                <th className="px-4 py-2">Address</th>
                <th className="px-4 py-2">Date</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {colleges.map((college, index) => (
                <tr key={college._id} className="border-b">
                  <td className="px-4 py-2">{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td className="px-4 py-2">{college.name}</td>
                  <td className="px-4 py-2">{college.address}</td>
                  <td className="px-4 py-2">{new Date(college.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: '2-digit' })}</td>
                  <td className="px-4 py-2">
                    <div className="flex gap-2">
                      <NavLink
                        to="/view-college"
                        state={{ type: "view", data: college }}
                        className="bg-blue text-white px-3 py-1 rounded text-sm"
                      >
                        View
                      </NavLink>
                      {(userRole?.role === "admin" || userRole?.managers?.["College Manager"]?.add) && (
                        <NavLink
                          to="/edit-college"
                          state={{ type: "edit", data: college }}
                          className="bg-orange text-white px-3 py-1 rounded text-sm"
                        >
                          Edit
                        </NavLink>
                      )}
                      {(userRole?.role === "admin" || userRole?.managers?.["College Manager"]?.delete) && (
                        <button
                          onClick={() => {
                            setDeleteId(college._id);
                            openModal();
                          }}
                          className="bg-red-500 text-white px-3 py-1 rounded text-sm"
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {pagination.totalPages > 1 && (
          <div className="flex justify-center mt-6 gap-2">
            <button
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={!pagination.hasPrevPage}
              className="px-3 py-1 border rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
            >
              Previous
            </button>
            <span className="px-3 py-1">
              Page {pagination.currentPage} of {pagination.totalPages} ({pagination.totalItems} items)
            </span>
            <button
              onClick={() => setCurrentPage(Math.min(pagination.totalPages, currentPage + 1))}
              disabled={!pagination.hasNextPage}
              className="px-3 py-1 border rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
            >
              Next
            </button>
          </div>
        )}
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-lg font-semibold">Are you sure you want to delete?</h2>
            <div className="mt-4 flex justify-center space-x-4">
              <button
                className="bg-gray-500 text-white px-4 py-2 rounded-md"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white px-4 py-2 rounded-md"
                onClick={confirmDeletion}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
